import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, MessageCircle } from "lucide-react";
import { SITE, PALMS } from "../mock";
import WindPalm from "./WindPalm";

const Footer = () => {
  return (
    <footer className="relative bg-[#1f2a24] text-[#e8dfca] overflow-hidden">
      {/* A single subtle palm in the footer */}
      <WindPalm
        src={PALMS.pair}
        side="right"
        offsetX={-110}
        bottom={-30}
        width={380}
        opacity={0.32}
        silhouette
        parallax={0.05}
        scrollIntensity={1.0}
        swayDuration={9.0}
        zIndex={1}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 py-20 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif-display text-3xl md:text-4xl mb-3">Casa Elio</div>
          <p className="text-sm leading-relaxed max-w-md opacity-80">
            A boutique retreat in San Juan del Sur, Nicaragua — 5 luxury suites with king beds, ocean views, and the slow horizon of the Pacific.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href={SITE.bookingUrl}
              target="_blank"
              rel="noreferrer"
              className="text-[11px] uppercase tracking-[0.25em] px-5 py-3 bg-[#f5f0e6] text-[#1f2a24] hover:bg-[#e8dfca] transition-colors"
            >
              Book on Booking.com
            </a>
            <a
              href={SITE.airbnbUrl}
              target="_blank"
              rel="noreferrer"
              className="text-[11px] uppercase tracking-[0.25em] px-5 py-3 border border-[#e8dfca]/40 hover:bg-[#e8dfca] hover:text-[#1f2a24] transition-colors"
            >
              Book on Airbnb
            </a>
          </div>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] opacity-60 mb-4">Visit</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/rooms" className="hover:text-white">Suites</Link></li>
            <li><Link to="/experience" className="hover:text-white">Experience</Link></li>
            <li><Link to="/gallery" className="hover:text-white">Gallery</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] opacity-60 mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <MapPin size={14} className="mt-1 flex-none opacity-70" />
              <span>San Juan del Sur, Rivas, Nicaragua</span>
            </li>
            <li className="flex items-start gap-2">
              <MessageCircle size={14} className="mt-1 flex-none opacity-70" />
              <a
                href={`https://wa.me/${SITE.whatsappRaw}`}
                target="_blank"
                rel="noreferrer"
                className="hover:text-white"
              >
                WhatsApp {SITE.whatsapp}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={14} className="mt-1 flex-none opacity-70" />
              <a href={`mailto:${SITE.email}`} className="hover:text-white">
                {SITE.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row gap-3 justify-between text-[11px] uppercase tracking-[0.25em] opacity-60">
          <span>© {new Date().getFullYear()} Casa Elio</span>
          <span>Boutique Villa · San Juan del Sur · Nicaragua</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
